<template>
	<div class='verify-box'>
		<div class="title black">
			畅由积分→{{xgTheme.transTitle}}
		</div>
		<div class="step-box">
			<div class='flex pay-info'>
				<div class="pink">
					<div class="f-s-22 w-600 t-c">{{order.cyScore}}</div>
					<div class="f-s-16 t-c">畅由积分</div>
				</div>
				<div class="t-c">
					<div class="zh-div">
						<img src="../../assets/zh.png">
					</div>
				</div>
				<div class="blue">
					<div class="f-s-22 w-600 t-c">{{order.reserved2}}</div>
					<div class="f-s-16 t-c">{{order.reserved1}}</div>
				</div>
			</div>
			<div class="p-t-20">
				<Verify :step="step" :smsStatus="smsStatus" :order="order" @payError="payError"></Verify>
			</div>
			<div class="f-s-10 orange t-c p-t-6">*本次兑换将直接扣除畅由积分，无需扣除移动积分</div>
		</div>
	</div>
</template>

<script>
	import Verify from './Verify.vue'
	import {
		mapState,
		mapGetters,
		mapMutations,
		mapActions
	} from "vuex"
	export default {
		computed: mapGetters(['xgTheme']),
		name: 'OnceCode',
		components: {
			[Verify.name]: Verify
		},
		data() {
			return {
				step:2
			}
		},
		props: {
			smsStatus: {
				type: Number,
				default: 0
			},
			order: {
				type: Object,
				default: {}
			}
		},
		methods: {
			doAuto() {

			},
			payError(){
				this.$emit('payErrorPoss')
			}
		},
	}
</script>

<style scoped>
	.verify-box {
		width: 300px;
		height: max-content;
	}

	.step-box {
		padding: 30px 20px;
		background-color: #ffffff;
	}

	.title {
		background-color: #f8eee3;
		padding: 15px 0;
		text-align: center;
		font-size: 20px;
		font-weight: 550;
	}

	.pay-info>div {
		flex: 1;
	}
	
	.zh-div {
		width: 50px;
		margin: auto;
	}
	.zh-div>img{
		width: 100%;
	}
</style>
